import { TriangleAlert } from 'lucide-react';
import { useSearchParams } from 'react-router';
import { apiPaths, type NowResponse, type StopsResponse } from '../../../shared/api/contract.ts';
import { DEFAULT_CITY } from '../../../shared/cities/index.ts';
import type { TransportLine } from '../../../shared/domain/index.ts';
import { FRESHNESS_POLICIES } from '../../../shared/freshness/index.ts';
import { LineBadge } from '../../components/LineBadge.tsx';
import { PageContainer } from '../../components/layout/PageContainer.tsx';
import { SectionCard } from '../../components/SectionCard.tsx';
import { useApi } from '../../hooks/useApi.ts';
import { formatDayTime } from '../../lib/format.ts';
import { DeparturesBoard } from './DeparturesBoard.tsx';

export function TransportPage() {
  const [params] = useSearchParams();
  const now = useApi<NowResponse>(apiPaths.now(DEFAULT_CITY.slug), FRESHNESS_POLICIES.disruptions.refreshMs);
  const stops = useApi<StopsResponse>(apiPaths.stops(DEFAULT_CITY.slug));
  const linesById = new Map((stops.data?.lines ?? []).map((line: TransportLine) => [line.id, line]));

  return (
    <PageContainer path="/transports" split>
      <DeparturesBoard limit={10} initialStopId={params.get('gare')} />
      <SectionCard
        title="Information trafic"
        icon={<TriangleAlert size={20} aria-hidden="true" />}
        kind="disruptions"
        section={now.data?.network}
        loading={now.loading}
        fetchError={now.error}
      >
        {(network) =>
          network.disruptions.length === 0 ? (
            <p className="state-message">Aucun message sur les lignes desservant Ermont.</p>
          ) : (
            <ul className="disruptions">
              {network.disruptions.map((d) => (
                <li key={d.id} className="disruption">
                  <span className="disruption__lines">
                    {d.lineIds.map((id) => {
                      const line = linesById.get(id);
                      return line === undefined ? null : <LineBadge key={id} line={line} />;
                    })}
                    <strong>{d.title}</strong>
                  </span>
                  {d.message}
                  {d.validUntil !== undefined && <> · jusqu’au {formatDayTime(d.validUntil)}</>}
                </li>
              ))}
            </ul>
          )
        }
      </SectionCard>
    </PageContainer>
  );
}
